var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 401.74 119.02",
    style: {
      enableBackground: "new 0 0 401.74 119.02"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D6CCF2"
    },
    cx: 154.65,
    cy: 43.47,
    r: 37.36
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#674893"
    },
    cx: 154.65,
    cy: 43.47,
    r: 28.61
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E334FF"
    },
    d: "M12.31,85.68v-13.8c2.5,2.1,5.22,3.67,8.15,4.72c2.93,1.05,5.89,1.57,8.88,1.57 c1.75,0,3.28-0.16,4.59-0.47c1.31-0.32,2.4-0.75,3.28-1.32s1.53-1.22,1.96-1.98c0.43-0.76,0.65-1.59,0.65-2.48 c0-1.21-0.34-2.29-1.04-3.23c-0.69-0.95-1.63-1.83-2.82-2.63c-1.19-0.8-2.61-1.58-4.25-2.33s-3.41-1.51-5.3-2.29 c-4.83-2.01-8.43-4.47-10.8-7.38c-2.37-2.9-3.56-6.41-3.56-10.52c0-3.22,0.65-5.99,1.94-8.3s3.05-4.22,5.28-5.71 c2.23-1.49,4.81-2.59,7.74-3.3c2.93-0.7,6.04-1.06,9.32-1.06c3.22,0,6.07,0.19,8.56,0.58c2.49,0.39,4.78,0.99,6.88,1.79v12.89 c-1.04-0.72-2.16-1.35-3.39-1.9c-1.22-0.55-2.48-1-3.77-1.36c-1.29-0.36-2.58-0.63-3.86-0.8c-1.28-0.17-2.5-0.26-3.64-0.26 c-1.58,0-3.02,0.15-4.31,0.45s-2.39,0.73-3.28,1.27c-0.89,0.55-1.58,1.2-2.07,1.96c-0.49,0.76-0.73,1.62-0.73,2.57 c0,1.03,0.27,1.96,0.82,2.78c0.55,0.82,1.32,1.6,2.33,2.33c1.01,0.73,2.23,1.45,3.67,2.16c1.44,0.71,3.06,1.43,4.87,2.18 c2.47,1.04,4.69,2.13,6.66,3.3c1.97,1.17,3.66,2.48,5.07,3.95c1.41,1.47,2.49,3.14,3.23,5.02c0.75,1.88,1.12,4.08,1.12,6.58 c0,3.45-0.65,6.35-1.96,8.69c-1.31,2.34-3.08,4.24-5.33,5.69c-2.24,1.45-4.85,2.49-7.83,3.13c-2.98,0.63-6.12,0.95-9.42,0.95 c-3.39,0-6.62-0.29-9.68-0.86C17.2,87.69,14.55,86.83,12.31,85.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E334FF"
    },
    d: "M77.13,82.92h-0.17v25.44H63.33V43.89h13.63v6.64h0.17c3.36-5.15,8.09-7.72,14.19-7.72 c5.72,0,10.14,1.96,13.26,5.89c3.12,3.92,4.68,9.27,4.68,16.02c0,7.36-1.82,13.27-5.46,17.73c-3.64,4.46-8.47,6.68-14.51,6.68 C83.97,89.13,79.92,87.06,77.13,82.92z M76.74,64.81v3.54c0,3.05,0.8,5.54,2.42,7.46c1.61,1.93,3.72,2.89,6.34,2.89 c3.1,0,5.51-1.2,7.22-3.6c1.71-2.4,2.57-5.8,2.57-10.2c0-7.76-3.02-11.64-9.06-11.64c-2.79,0-5.07,1.06-6.83,3.17 C77.63,58.53,76.74,61.33,76.74,64.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E334FF"
    },
    d: "M237.33,87.54c-2.01,1.06-5.05,1.6-9.1,1.6c-9.6,0-14.4-4.99-14.4-14.96V53.94h-7.16V43.89h7.16 v-9.53l13.58-3.88v13.41h9.92v10.05h-9.92v17.85c0,4.6,1.83,6.9,5.48,6.9c1.44,0,2.92-0.42,4.44-1.25V87.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E334FF"
    },
    d: "M258.63,88.05H245V22.67h13.63V88.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E334FF"
    },
    d: "M277,36.9c-2.3,0-4.18-0.68-5.65-2.05c-1.47-1.37-2.2-3.04-2.2-5.02c0-2.04,0.73-3.71,2.2-5 c1.47-1.29,3.35-1.94,5.65-1.94c2.33,0,4.22,0.65,5.67,1.94c1.45,1.29,2.18,2.96,2.18,5c0,2.07-0.73,3.77-2.18,5.09 C281.22,36.24,279.33,36.9,277,36.9z M283.73,88.05H270.1V43.89h13.63V88.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E334FF"
    },
    d: "M324.01,33.11c-1.75-0.69-3.44-1.04-5.05-1.04c-4.37,0-6.56,2.37-6.56,7.12v4.7h10.09v10.05h-10.09 v34.11h-13.58V53.94h-7.42V43.89h7.42v-5.48c0-5.03,1.64-9.08,4.92-12.16c3.28-3.08,7.73-4.61,13.37-4.61 c2.76,0,5.06,0.29,6.9,0.86V33.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E334FF"
    },
    d: "M357.35,87.54c-2.01,1.06-5.05,1.6-9.1,1.6c-9.6,0-14.4-4.99-14.4-14.96V53.94h-7.16V43.89h7.16 v-9.53l13.58-3.88v13.41h9.92v10.05h-9.92v17.85c0,4.6,1.83,6.9,5.48,6.9c1.44,0,2.92-0.42,4.44-1.25V87.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E334FF"
    },
    d: "M362.14,86.89V75.85c2.24,1.35,4.48,2.36,6.71,3.02c2.23,0.66,4.33,0.99,6.32,0.99 c2.42,0,4.32-0.33,5.71-0.99s2.09-1.67,2.09-3.02c0-0.86-0.32-1.58-0.95-2.16c-0.63-0.57-1.44-1.08-2.44-1.51 c-0.99-0.43-2.08-0.82-3.26-1.16c-1.18-0.34-2.31-0.73-3.41-1.16c-1.75-0.66-3.3-1.37-4.64-2.13s-2.46-1.65-3.36-2.65 c-0.91-1.01-1.6-2.17-2.07-3.49c-0.47-1.32-0.71-2.89-0.71-4.7c0-2.47,0.54-4.6,1.62-6.38c1.08-1.78,2.52-3.24,4.31-4.38 s3.85-1.97,6.17-2.5c2.31-0.53,4.72-0.8,7.22-0.8c1.96,0,3.94,0.15,5.95,0.45c2.01,0.3,4,0.74,5.95,1.32V55.1 c-1.73-1.01-3.57-1.76-5.54-2.26c-1.97-0.5-3.9-0.75-5.8-0.75c-0.89,0-1.73,0.08-2.52,0.24c-0.79,0.16-1.49,0.39-2.09,0.69 c-0.6,0.3-1.08,0.69-1.42,1.17c-0.35,0.47-0.52,1.01-0.52,1.62c0,0.81,0.26,1.5,0.78,2.07s1.19,1.07,2.03,1.49 c0.83,0.42,1.76,0.79,2.78,1.12c1.02,0.33,2.03,0.67,3.04,1.01c1.81,0.63,3.45,1.32,4.92,2.07c1.47,0.75,2.72,1.63,3.77,2.63 c1.05,1.01,1.85,2.19,2.42,3.54c0.56,1.35,0.84,2.96,0.84,4.83c0,2.62-0.57,4.85-1.7,6.71c-1.14,1.85-2.65,3.36-4.53,4.53 c-1.88,1.16-4.05,2.01-6.51,2.54s-5.01,0.8-7.66,0.8C370.78,89.13,366.28,88.38,362.14,86.89z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E334FF"
    },
    cx: 160.65,
    cy: 61.47,
    r: 37.36
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 160.65,
    cy: 61.47,
    r: 28.61
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E334FF"
    },
    cx: 160.65,
    cy: 61.47,
    r: 6
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ffcc782b905ceb1436659fe7918a29c.svg";
export { ForwardRef as ReactComponent };